<template>
  <table border="1" cellspacing="0">
    <caption>
      当前模板无内容可修改
    </caption>
    <tr class="head">
      <td colspan="4" align="center">实名制信息</td>
    </tr>
    <tr class="line4">
      <td align="center" colspan="1">姓名</td>
      <td align="center" colspan="1"></td>
      <td align="center" colspan="1">性别</td>
      <td align="center" colspan="1"></td>
    </tr>
    <tr class="line4">
      <td align="center">单位</td>
      <td align="center"></td>
      <td align="center">入场时间</td>
      <td align="center"></td>
    </tr>
    <tr class="line4">
      <td align="center">年龄</td>
      <td align="center"></td>
      <td align="center">民族</td>
      <td align="center"></td>
    </tr>
    <tr>
      <td align="center">身份证号</td>
      <td align="center" colspan="3"></td>
    </tr>
    <tr>
      <td align="center">籍贯</td>
      <td align="center" colspan="3"></td>
    </tr>
    <tr class="head">
      <td colspan="4" align="center">体检信息</td>
    </tr>
    <tr class="line4">
      <td align="center">身高</td>
      <td align="center"></td>
      <td align="center">体重</td>
      <td align="center"></td>
    </tr>
    <tr class="line4">
      <td align="center">血压</td>
      <td align="center"></td>
      <td align="center">心率</td>
      <td align="center"></td>
    </tr>
    <tr class="head">
      <td colspan="4" align="center">教育培训信息（安全体验培训）</td>
    </tr>
    <tr>
      <td align="center">已进行的培训内容</td>
      <td align="center" colspan="3"></td>
    </tr>
    <tr class="head">
      <td colspan="4" align="center">教育培训信息（多媒体培训）</td>
    </tr>
    <tr>
      <td align="center">已进行的培训内容</td>
      <td align="center" colspan="3"></td>
    </tr>
    <tr class="head">
      <td colspan="4" align="center">考核信息</td>
    </tr>
    <tr>
      <td style="height: 80px" colspan="2" align="center">考核得分</td>
      <td style="height: 80px" colspan="2" align="center"></td>
    </tr>
  </table>
</template>

<script>
export default {};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: center;
}
table,
table tr th,
table tr td {
  border: 1px solid #000000;
}
table tr td {
  height: 45px;
}
.head {
  background: #ccc;
  color: #000;
  font-weight: bold;
}
.line4 td {
  width: 25%;
}
</style>